/**
 * MTE AuthCallback shell route — handler for Supabase PKCE flow (post-signup,
 * magic link, password reset).
 *
 * Após setup infra:
 * - Lê tokens via @supabase/ssr
 * - Persiste session
 * - Redireciona para /famille/accueil/ ou /update-password/
 *
 * Pré-infra: placeholder visual a informar "callback recebido".
 */
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Layout, Header } from '../../components/mte/shell';
import '../../styles/auth.css';

function AuthCallback(): JSX.Element {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'idle' | 'processing' | 'done' | 'error'>('idle');
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    const next = searchParams.get('next');
    const errorDescription = searchParams.get('error_description');
    if (errorDescription) {
      setStatus('error');
      setMessage(errorDescription);
      return;
    }
    setStatus('processing');
    setMessage('Validation en cours...');
    const timer = setTimeout(() => {
      setStatus('done');
      setMessage('Session confirmée.');
      setTimeout(() => navigate(next ?? '/famille/accueil/', { replace: true }), 600);
    }, 600);
    return () => clearTimeout(timer);
  }, [navigate, searchParams]);

  return (
    <Layout context="adulte" width="narrow" header={<Header context="adulte" />}>
      <main className="auth-page">
        <div className="auth-card">
          <h1 className="auth-h1">Confirmation en cours</h1>
          {status === 'error' ? (
            <div className="auth-error-region" role="alert" aria-live="assertive" data-testid="auth-callback-error">
              {message}
            </div>
          ) : (
            <div className="auth-message-success" role="status" aria-live="polite" data-testid="auth-callback-status">
              {message}
            </div>
          )}
        </div>
      </main>
    </Layout>
  );
}

export default AuthCallback;
